const StandardFonts = {
  h23240Semibold: {
    fontSize: 32,
    lineHeight: "40px",
    fontWeight: "600",
    fontFamily: "Inter",
  },
  h14048Bold: {
    fontSize: 40,
    lineHeight: "48px",
    fontWeight: "700",
    fontFamily: "Inter",
  },
  h32432Semibold: {
    fontSize: 24,
    lineHeight: "32px",
    fontWeight: "600",
    fontFamily: "Inter",
  },
  h42028Semibold: {
    fontSize: 20,
    lineHeight: "28px",
    fontWeight: "600",
    fontFamily: "Inter",
  },
  _h42028Semibold: {
    fontWeight: "600",
    fontFamily: "Inter",
    color: "#4B628A"
  },
  h51624Medium: {
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: "500",
    fontFamily: "Inter",
  },
  h51824Medium: {
    fontSize: 18,
    lineHeight: "24px",
    fontWeight: "500",
    fontFamily: "Inter",
  },
  body11420Medium: {
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: "500",
    fontFamily: "Inter",
  },
  body21220Medium: {
    fontSize: 12,
    lineHeight: "20px",
    fontWeight: "600",
    fontFamily: "Inter",
  },
  body11420Semibold: {
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: "600",
    fontFamily: "Inter",
  },
  body21220Bold: {
    fontSize: 12,
    lineHeight: "20px",
    fontWeight: "700",
    fontFamily: "Inter",
  },
  capture1016Medium: {
    fontSize: 10,
    lineHeight: "16px",
    fontWeight: "500",
    fontFamily: "Inter",
  },
  capture11424Medium: {
    fontWeight: "500",
    fontSize: 14,
    lineHeight: "24px",
    fontFamily: "Inter",
  },

  // new classes
  h42021Semibold : {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: "600",
    fontFamily: "Inter",
  },
  _body11420Medium: {
    fontSize: 14,
    lineHeight: "16px",
    fontWeight: "500",
    fontStyle: 'normal',
    fontFamily: "Inter",
  },
  _h51624Medium: {
    fontSize: 26,
    lineHeight: "24px",
    fontWeight: "600",
    fontFamily: "Inter",
  },
  _h51624Medium2: {
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: "600",
    fontFamily: "Inter",
  },
  _body21220Medium: {
    fontSize: 14,
    lineHeight: "14px",
    fontWeight: "500",
    fontFamily: "Inter",
  },
  _body21220Medium2: {
    fontSize: 12,
    lineHeight: "14px",
    fontWeight: "600",
    fontFamily: "Inter",
  }
};

export default StandardFonts;
